import { log2 } from "../utils/log2";
import { incomingChatSound } from "../utils/notificationSounds";
import chat from "../store/modules/chat";
import auth from "../store/modules/auth";
import store from "../store";
import _ from "lodash";

const log = log2("AttentionWorker");

let singleton = null;

export class AttentionWorker {
    constructor() {
        if (!!singleton) return;
        log("constructor");
        this.AFK = false;
        this.thresold = 1000;
        this.afkThresold = 30 * 1000;
        this.sound = incomingChatSound();
        this.runAFKDetector();
        setInterval(this.task.bind(this), this.thresold);
    }

    static start() {
        log("start", singleton);
        if (!singleton) singleton = new AttentionWorker();
        return singleton;
    }

    task() {
        const unreadChatsAvailable = chat.state.latestRows.some(
            (c) =>
                !chat.state.afkCheckedChatIds.includes(c._id) &&
                (!c.users ||
                    c.users.length === 0 ||
                    (!!c.users && c.users.length !== 0 && c.users.find((userId) => userId === auth.state.user._id)))
        );
        const unreadChatsAvailable2 = chat.state.conversations.some(
            (c) =>
                !chat.state.afkCheckedChatIds.includes(c._id) &&
                (!c.users ||
                    c.users.length === 0 ||
                    (!!c.users && c.users.length !== 0 && c.users.find((userId) => userId === auth.state.user._id)))
        );
        const infinitePlay = _.get(
            _.get(auth.state.user, "notificationSettings", []).find((x) => x.type === "new_chat"),
            "infinitePlay",
            false
        );

        // log.debug("task", `AFK: ${this.AFK} unreadChatsAvailable: ${unreadChatsAvailable} infinitePlay: ${infinitePlay}`);

        if (this.AFK && (unreadChatsAvailable || unreadChatsAvailable2) && infinitePlay) this.sound.play();
    }

    runAFKDetector() {
        log("runAFKDetector");
        const events = [
            "keydown",
            "keyup",
            "keypress",
            "mouseover",
            "mouseleave",
            "mousedown",
            "mouseup",
            "mouseenter",
            "mouseout",
            "mousemove",
        ];
        events.forEach((event) => window.addEventListener(event, this.checkedChats.bind(this)));
        setInterval(() => (this.AFK = true), this.afkThresold);
    }

    checkedChats() {
        this.AFK = false;
        const checkedChatIds = chat.state.latestRows.map((x) => x._id);
        const checkedChatIds2 = chat.state.conversations.map((x) => x._id);
        store.commit("chat/SET_AFK_CHECKED_CHATS", checkedChatIds.concat(checkedChatIds2));
    }
}
